import type { CharLook } from '@/gfx/characters';

export interface Trait {
  id: string;
  name: string;
  desc: string;
  runMul?: number;
  noiseMul?: number;
  lightRangeMul?: number;
  batteryMul?: number;
  sightMul?: number;
  groggyMul?: number;
  inventory?: number;
  pushMul?: number;
  senseMul?: number;
}

export interface FriendDef {
  id: string;
  name: string;
  look: CharLook;
  trait: Trait;
  /** short flavour line shown when picking who goes in next */
  line: string;
}

export const FRIENDS: FriendDef[] = [
  {
    id: 'jiwoo', name: '지우',
    look: { hair: 'black', style: 'short', cloth: 'red', pants: 'navy' },
    trait: { id: 'calm', name: '침착함', desc: '특별한 재주는 없지만 무엇이든 무난하게 해낸다.' },
    line: '가장 먼저 저택에 들어갔던 친구.',
  },
  {
    id: 'haneul', name: '하늘',
    look: { hair: 'blue', style: 'bangs', cloth: 'teal', pants: 'gray' },
    trait: { id: 'fast', name: '빠른 발', desc: '달리기 속도 +15%.', runMul: 1.15 },
    line: '육상부. 도망치는 건 자신 있다.',
  },
  {
    id: 'doyun', name: '도윤',
    look: { hair: 'brown', style: 'cap', cloth: 'green', pants: 'brown', accent: '#3f7a52' },
    trait: { id: 'quiet', name: '조용한 발걸음', desc: '발소리 -30%.', noiseMul: 0.7 },
    line: '말수도 적고 발소리도 적다.',
  },
  {
    id: 'seoyeon', name: '서연',
    look: { hair: 'blonde', style: 'long', cloth: 'yellow', pants: 'wine' },
    trait: { id: 'bright', name: '밝은 손전등', desc: '손전등 거리 +25%, 배터리 +30%.', lightRangeMul: 1.25, batteryMul: 1.3 },
    line: '아버지 손전등을 몰래 챙겨 왔다.',
  },
  {
    id: 'minjae', name: '민재',
    look: { hair: 'black', style: 'short', cloth: 'orange', pants: 'black' },
    trait: { id: 'strong', name: '힘', desc: '가구를 빨리 밀고, 그로기 시간 -50%.', pushMul: 1.8, groggyMul: 0.5 },
    line: '씨름부. 밀리는 건 딱 질색.',
  },
  {
    id: 'yuna', name: '유나',
    look: { hair: 'pink', style: 'bun', cloth: 'purple', pants: 'navy', blush: true },
    trait: { id: 'eyes', name: '좋은 눈', desc: '어둠 속 근거리 시야 +60%.', sightMul: 1.6 },
    line: '어둠에 눈이 빨리 익는다.',
  },
  {
    id: 'junho', name: '준호',
    look: { hair: 'brown', style: 'short', cloth: 'blue', pants: 'olive' },
    trait: { id: 'pockets', name: '큰 주머니', desc: '아이템 칸 +2.', inventory: 8 },
    line: '뭐든 일단 주머니에 넣고 본다.',
  },
  {
    id: 'soyul', name: '소율',
    look: { hair: 'white', style: 'ribbon', cloth: 'white', pants: 'gray', accent: '#c8433d', blush: true },
    trait: { id: 'brave', name: '담력', desc: '괴물의 기척을 더 멀리서 느낀다.', senseMul: 1.7 },
    line: '공포영화를 웃으면서 보는 아이.',
  },
];

export const INVENTORY_DEFAULT = 6;
